/**
 * @module support/shared
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 * helper funtion to generate random number using crypto
 * getRandomValues returnes integer from 0 to max 32 bit as we use Uint32Array
 * we excluded -1 as Math.random excludes 1
 * @returns number
 */

export const randomNumber = (): number => {
  const rangeInit: number = 2;
  const rangeMax: number = 32;
  const maxBitRange = Math.pow(rangeInit, rangeMax);
  const randomNumber = self.crypto.getRandomValues(new Uint32Array(1))[0] / maxBitRange;
  return randomNumber;
};
